module.exports = __webpack_public_path__ + "img/knet.bf230a5f.png";